import { Card, CardContent, IconButton, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import AddConnectionDialog from "./AddConnectionDialog";

export default function AddConnection() {
  const [open, setOpen] = useState(false);

  return <>
    <Card sx={{ minHeight: "310px", height: "100%" }}>
      <CardContent sx={{ alignItems: "center", justifyContent: "center", gap: "20px" }}>
        <IconButton color="primary" onClick={() => setOpen(true)}>
          <AddIcon />
        </IconButton>
        <Typography variant="subtitle1" color="secondary">Add connection</Typography>
      </CardContent>
    </Card>
    {open && <AddConnectionDialog
      open={open}
      onClose={() => setOpen(false)}
    />}
  </>
}